import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16770a9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area-jobInfo" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "table matadata" }
const _hoisted_4 = { class: "id" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "処理ID", -1))
const _hoisted_6 = { class: "startAt" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "処理開始", -1))
const _hoisted_8 = { class: "endAt" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "処理終了", -1))
const _hoisted_10 = { class: "status" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "処理結果", -1))
const _hoisted_12 = {
  key: 0,
  class: "label-process-status processing"
}
const _hoisted_13 = {
  key: 1,
  class: "label-process-status complete"
}
const _hoisted_14 = {
  key: 2,
  class: "label-process-status refusal"
}
const _hoisted_15 = { class: "successItemCount" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "登録成功", -1))
const _hoisted_17 = { class: "errorItemCount" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "登録失敗", -1))
const _hoisted_19 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.jobInfo.id), 1)
          ]),
          _createElementVNode("tr", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_ctx.splitDate(_ctx.props.jobInfo.startAt)), 1)
          ]),
          _createElementVNode("tr", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_ctx.splitDate(_ctx.props.jobInfo.endAt)), 1)
          ]),
          _createElementVNode("tr", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("td", null, [
              (_ctx.convertStatus(_ctx.props.jobInfo.status) === '処理中')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _createVNode(_component_DssIcon, { icon: 'status-processing' }),
                    _createTextVNode(" " + _toDisplayString(_ctx.convertStatus(_ctx.props.jobInfo.status)), 1)
                  ]))
                : (_ctx.convertStatus(_ctx.props.jobInfo.status) === '終了')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createVNode(_component_DssIcon, { icon: 'status-complete' }),
                      _createTextVNode(" " + _toDisplayString(_ctx.convertStatus(_ctx.props.jobInfo.status)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createVNode(_component_DssIcon, { icon: 'status-refusal' }),
                      _createTextVNode(" " + _toDisplayString(_ctx.convertStatus(_ctx.props.jobInfo.status)), 1)
                    ]))
            ])
          ]),
          _createElementVNode("tr", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("td", null, _toDisplayString(_ctx.convertNull(_ctx.props.jobInfo.successItemCount)) + "件", 1)
          ]),
          _createElementVNode("tr", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.convertNull(_ctx.props.jobInfo.errorItemCount)) + "件", 1)
          ])
        ])
      ])
    ])
  ]))
}